// eslint-disable-next-line consistent-return
function getStateModules(vm) {
  // options may be = undefined in functional components
  if (!vm.$options) {
    return false;
  }

  const { stateModules } = vm.$options;
  if (stateModules) {
    return typeof stateModules === 'function'
      ? stateModules.call(vm)
      : stateModules;
  }

  return false;
}

const serverMixin = {
  asyncData() {
    const stateModules = getStateModules(this);
    if (stateModules) {
      Object.keys(stateModules).forEach((module) => {
        this.$store.registerModule(module, stateModules[module]);
      });
    }
  },
};

const clientMixin = {
  mounted() {
    const stateModules = getStateModules(this);
    if (stateModules) {
      Object.keys(stateModules).forEach((module) => {
        this.$store.registerModule(module, stateModules[module], { preserveState: true });
      });
    }
  },
};

export default process.env.VUE_ENV === 'server'
  ? serverMixin
  : clientMixin;
